import { requireAuth } from '@/router/helpers';

/**
 * FE routes
 */
const FeRoutes = [
  // events front page
  {
    path: '/schedule/events',
    name: 'EventsIndexPage',
    component: () => import('@/views/events/Index'),
    beforeEnter: requireAuth,
  },
  {
    path: '/schedule/event/:id',
    name: 'EventsSinglePage',
    components: {
      default: () => import('@/views/events/Index'),
      panel: () => import('@/views/events/Event'),
    },
    beforeEnter: requireAuth,
    meta: { isAdmin: false, openPanel: true, whiteBg: true },
  },

  /**
   * Admin routes
   */
];

const AdminRoutes = [
  {
    path: '/admin/events',
    name: 'AdminEventsIndexPage',
    component: () => import('@/views/events/admin/Index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/events/create',
    name: 'AdminEventsCreate',
    component: () => import('@/views/events/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/events/:tabFilter',
    name: 'AdminEventsIndexPageFilter',
    component: () => import('@/views/events/admin/Index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: '/admin/events/edit/:id',
    name: 'AdminEventsEdit',
    component: () => import('@/views/events/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
];

export default [...FeRoutes, ...AdminRoutes];
